import templateUrl from './calendar-list-mobile-view.html';

export const calendarListMobileViewComponent = {
    bindings: {
        details: '<',
        onEventClick: '&',
        calendarType: '@'
    },
    templateUrl,
    controller: class CalendarListMobileViewComponent {
        constructor() {
            'ngInject';
        }

        $onInit() {
            if(this.calendarType === "event")
                this.templateUrl = 'eventMobileViewTemplate.html';
        }

        _onEventClick(dayDetail) {
            this.onEventClick({ dayDetail });
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/common/components/calendar-list-mobile-view/calendar-list-mobile-view.component.js